import React from 'react'
import styles from "./NewModal.module.css"
const NewModal = ({ show, children }) => {
    if (!show) {
        return null
    }
    return (
        <div className={styles.modalbackdrop}>
            <div className={styles.modalcontent}>
                {children}
            </div>
        </div>
    )
}

export default NewModal
